import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

interface ManageTemplateFormItemProps {
    children: ReactNode;
    className?: string;
}

const ManageTemplateFormItem = (
    props: ManageTemplateFormItemProps
): JSX.Element => {
    const { children, className } = props;

    return (
        <Box className={className} sx={{ mb: 2 }}>
            {children}
        </Box>
    );
};

export default ManageTemplateFormItem;
